<template>
  <div class="myself">
    <div class="not-login" v-if="!user">
      <div class="login-btn" @click="$router.push('/login')">
        <img src="../../assets/loginback.jpg" alt="">
<!--        <span class="text">登录/注册</span>-->
      </div>
    </div>
    <div v-else class="logined-container">
      <div  class="logined">
        <div class="logined-user">
          <span>Hi {{user.userName}}</span>
          <img src="../../assets/avator.png" alt="">
        </div>
        <div class="logined-sort">
          <div class="login-total">
            <i class="icon-a-Vector2Stroke iconfont"></i>
            <span>累计捐赠</span>
          </div>
          <div class="logined-number">
            <div class="logined-num-left">
              <div>

              </div>
<!--              <span v-if="userObject.puid<16">{{userObject.sumAmount+2750}}元</span>-->
<!--              <span v-else>{{userObject.sumAmount}}元</span>-->
              <span>{{totalNum}}元</span>
            </div>
<!--            <div class="login-num-right">-->
<!--              <span @click="goLoveRaise">排名：</span>-->
<!--              <span>{{userObject.rowNum}} ></span>-->
<!--            </div>-->

          </div>

        </div>
        <div class="logined-nav">
          <ul>
            <li :class="currentIndex == 0 ? 'active':''" @click="changeHandler(0)" >
              <span class="icon-new2 iconfont"></span>
              <span>捐助记录</span>
            </li>
            <li :class="currentIndex == 1 ? 'active':''" @click="changeHandler(1)">
              <span class="icon-a-Group51 iconfont"></span>
              <span>爱心反馈</span>
            </li>
            <li :class="currentIndex == 2 ? 'active':''" @click="changeHandler(2)">
              <span class="icon-a-Group52 iconfont"></span>
              <span>荣誉证书</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="login-content" style="display: block">
        <div class="donation-record" v-show="currentIndex==0">
         <ul v-if="recordList.length>0">
           <li  v-for="(item,index) in recordList" :key="index">
             <div class="img-container" v-if="item.psPhoLink ">
               <img :src="item.psPhoLink" alt="">

             </div>
             <div class="img-containers" v-else>
               <img :src="JSON.parse(item.pPhoLink).idxLink" alt="">
             </div>
             <div class="donation-content-right">
               <div class="donation-record-title">
                 <span v-if="item.proId ==1">爱心学费2022春季</span>
                 <span v-if="item.proId ==2">爱心学费2022秋季</span>
                 <span v-if="item.proId ==3"> 爱心图书2022</span>
               </div>
               <div class="donation-record-num">
                 <span>{{item.ordAmount}}</span>
                 <span>元</span>
                 <span style="display: inline-block;padding: 0 3px;">/</span>
                 <span>{{item.successTime | formatTime}}</span>
                 <span></span>
               </div>
               <div class="donation-record-cert" v-if="item.stuName">
                 <span>已认捐：</span>
                 <span @click="toDetail(item)">{{item.stuName}}</span>
                 <span @click="lookcert(item)">・查看证书</span>
               </div>
               <div class="donation-record-cert" v-else >
                 <span  @click="lookcert(item)">查看证书</span>
               </div>

             </div>
           </li>
         </ul>
          <div class="login-content-no" v-else>
<!--            <i class="iconfont icon-a-Group29"></i>-->
            <img src="../../assets/norecord.png" alt="">
            <span class="no-record">暂无捐款记录</span>
            <div class="login-donation" @click="donationHander">
              <span>我要参与捐款</span>
            </div>
          </div>
        </div>
        <div class="love-feadback"  v-show="currentIndex==1">
          <ul v-if="loveRespList.length>0">
             <li @click="videoPlay(item)" v-for="(item,index) in loveRespList" :key="index">
              <div class="img-container">
                <div class="img-video">
                  <img src="../../assets/video.png" alt="">
                </div>
                <img :src="item.lgLink" alt="">
              </div>
              <div class="donation-content-right">
                <div class="donation-feadback-title">
                  <span style="font-weight: bold;padding-bottom: 10px;display: inline-block">{{item.lgTitle}}</span>
                </div>
                <div class="donation-feadback-cert">
                  <span>立即观看</span>
                </div>
              </div>
            </li>
          <van-popup v-model="videoShow" @close="popuoCLose">
              <div class="video-wrapper">
                <video
                    ref="video"
                    class="video-js vjs-default-skin"
                    controls
                    :poster="lgLink"
                    :src = lgVideo
                >
                </video>
              </div>
            </van-popup>
          </ul>
          <div class="login-content-no" v-else>
<!--            <i class="iconfont icon-a-Group29"></i>-->
            <img src="../../assets/norecord.png" alt="">
            <span class="no-record">暂无爱心视频</span>
            <div class="login-donation" @click="donationHander">
              <span>我要参与捐款</span>
            </div>
          </div>
        </div>
        <div class="honor-cert"  v-show="currentIndex==2" >
          <div v-if="loveCertList.length">
            <swiper class="swiper" :options="swiperOption">
              <swiper-slide v-for="(item,index) in loveCertList" v-bind:key="index">
                <img v-bind:src="item.lgLink">
              </swiper-slide>
              <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
          </div>
        <div class="login-content-no" v-else>
          <img src="../../assets/norecord.png" alt="">
          <span class="no-record">暂无荣誉证书</span>
          <div class="login-donation" @click="donationHander">
            <span>我要参与捐款</span>
          </div>
        </div>
      </div>

    </div>

    <van-popup v-model="certshow" :close-on-click-overlay="false" >
      <div class="certimg">
        <img :src="cerimg" alt="">
      </div>
      <div class="cert-text">
          长按图片下载证书
      </div>
      <div class="cert-icon">
        <van-icon name="close" @click="closeIcon" />
      </div>
    </van-popup>
  </div>
  </div>
</template>

<script>
import {proOrders, proUserInfo, loveResp,loveCert} from '../../api'
import {mapState} from 'vuex'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
// import palyVideo from "../../component/palyVideo";
export default {
  name: "index",
  computed:{
    ...mapState(['user'])
  },
  data(){
    return{
      totalNum:0,
      cerimg:'',
      certshow:false,
      currentIndex:0,
      time:'2022.06.12 12:08',
      recordList:[],
      src:'https://testsohochina.oss-cn-beijing.aliyuncs.com/dev/2020/07/t7kjvluha9pw.mp4',
      videoShow:false,
      userObject:{},
      loveRespList:[],
      loveCertList:[],
      lgLink:'',
      lgVideo:'',
      swiperOption: { //同swiper
        slidesPerView: 1,
        // spaceBetween: 30,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction',
        },
        // navigation: {
        //   nextEl: '.swiper-button-next',
        //   prevEl: '.swiper-button-prev'
        // }
      }
    }
  },
  components:{
    Swiper,
    SwiperSlide
  },
  mounted() {
    if(this.user){
      this.onLoad()
      this.proUserInfo()
      this.loveResp()
      this.loveCert()
    }

  },
  methods:{
  async loveCert(){
      const data = await loveCert({'puId':this.user.puId})
      if(data.code == 200){
        this.loveCertList = data.data
      }
    },
    async loveResp(){
      const data = await loveResp({'puId':this.user.puId})
      if(data.code == 200){
        this.loveRespList = data.data

      }
    },
    closeIcon(){
       this.certshow = false
    },
    lookcert(item){
      this.cerimg = item.lgLink
      this.certshow = true
    },
    toDetail(item){
       this.$router.push({
        path: '/detail',
        query:{id:item.psId, proId:item.proId,stuId:item.stuId,stuname:item.stuName}
      })
    },
    videoPlay(item){
      this.lgVideo = item.lgVideo
      this.lgLink = item.lgLink
      this.videoShow = true
      setTimeout(()=>{
        console.log(this.$refs.video)
        this.$refs.video.play()
      },1000)

    },
    async proUserInfo(){
      const data = await proUserInfo({'puId':this.user.puId})
      if(data.code == 200){
        this.userObject = data.data
        console.log(this.userObject.puId)
        if(this.userObject.puId <16){
          this.totalNum = this.userObject.sumAmount+2750
        }else {
          this.totalNum = this.userObject.sumAmount
        }
      }
    },
    async onLoad(){
      const data = await proOrders({'page':1,'limit':50 ,'puId':this.user.puId})
      if(data.code == 200){
        this.recordList = data.data.list
        console.log(this.recordList)
      }
    },
    changeHandler(index){
      this.currentIndex = index
    },
    donationHander(){
      this.$router.push('/')
    },
    popuoCLose(){
      let video =this.$refs.video
      video.currentTime = 0;
      video.pause()
    },
    goLoveRaise(){
      this.$router.push('/loveraise')
    },
    FullScreen() {
      var ele =  this.$refs.video
          if (ele .requestFullscreen) {
              ele .requestFullscreen();
          } else if (ele .mozRequestFullScreen) {
              ele .mozRequestFullScreen();
          } else if (ele .webkitRequestFullScreen) {
              ele .webkitRequestFullScreen();
          }

      },
  }
}
</script>
<style>
  .van-popup {
    background-color: transparent !important;
  }
</style>
<style scoped lang="scss">

  //.swiper-pagination{
  //  position: fixed
  //}
    //.swiper-container{
  //  overflow: visible !important;
  //}
  .swiper-pagination-fraction, .swiper-pagination-custom, .swiper-container-horizontal > .swiper-pagination-bullets{
    bottom: 60px;
    color:#BDB4BE
  }
.myself{
  display: flex;
  width: 100%;
  height: 100%;
  padding-bottom: 200px;
  .not-login{
    height:100%;
    width: 100%;
    //background-color: #A471AA;
    //background: url("~@/assets/loginback.jpg");
    //background-size: cover;
    display: flex;
    justify-content: center;
    align-items: center;
    .login-btn{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      img {
       display: block;
        width: 100%;
      }
      span{
        font-size: 28px;
        color: #FFFFFF;
      }
    }
  }
  .logined-container{
    width: 100%;
    .logined{

      height: 600px;
      background: url("../../assets/myHeader.png");
      background-size: cover;
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      position: relative;
      //padding: 0px 50px 0;
      box-sizing: border-box;
      .logined-user{
        width: 90%;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 20px;
        span{
          font-family: 'PingFang SC';
          font-style: normal;
          font-weight: 600;
          font-size: 48px;
          line-height: 153%;
          color: #FFFFFF;
        }
        img{
          width: 100px;
          height: 100px;
        }
      }
      .logined-sort{
        width: 90%;
        margin: 0 auto;
        background: rgba(255, 255, 255, 0.1);
        border: 1px solid #C199C6;
        border-radius: 10px;
        height: 160px;
        box-sizing: border-box;
        padding: 20px 30px 0;
        display: flex;
        flex-direction: column;
        .login-total{
          .iconfont{
            font-size: 28px;
            color: #FFFFFF;
            opacity: 0.56;

          }
          span{
            font-family: 'PingFang SC';
            font-style: normal;
            font-weight: 600;
            font-size: 28px;
            line-height: 153%;
            color: #FFFFFF;
            opacity: 0.56;
            display: inline-block;
            margin-left: 12px;
          }
        }
        .logined-number{
          display: flex;
          justify-content: space-between;
          margin-top: 10px;
          .logined-num-left{
            font-family: 'PingFang SC';
            font-style: normal;
            line-height: 153%;
            color: #FFFFFF;
            margin-top: 10px;
            span{
              font-weight: 500 ;
              font-size: 48px;
            }
          }
          .login-num-right{
            border: 1px solid #F1E4B9;
            height: 70px;
            line-height: 70px;
            border-radius: 10px;
            padding: 0 20px;
            span{
              font-family: 'PingFang SC';
              font-style: normal;
              font-weight: 600;
              font-size: 28px;
              color: #F1E4B9;
            }
          }
        }
      }
      .logined-nav{
        width: 90%;
        height: 200px;
        position: absolute;
        //background-color: rgba(0, 0, 0, 0.05);
        background-color: #FFFFFF;
        left: 5%;
        bottom: -70px;
        box-shadow: 1px 4px 5px rgba(0, 0, 0, 0.05);
        border-radius: 11px;
        display: flex;
        align-items: center;
        ul{
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 200px;
          li{
            width: 33%;
            box-sizing: border-box;
            .iconfont{
              font-size: 48px;
              margin-bottom: 20px;
            }
            span{
              display: block;
              text-align: center;
              font-family: 'PingFang SC';
              font-style: normal;
              font-weight: 500;
              font-size: 28px;
              color: #887E89;
            }
          }
          li:nth-child(1){
            border-right: 1px solid #EAEAF8;
          }
          li:nth-child(2){
            border-right: 1px solid #EAEAF8;
          }
          .active{
            span{
              color: #A471AA;
              font-weight: 500;
            }

          }
        }
      }
    }
    .login-content{
      width: 90%;
      padding-bottom: 150px;
      margin: 100px auto 0;
      .donation-record{
        ul{
          li{
            margin-top: 20px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-bottom: 30px;
            border-bottom: 1px solid #DFDCDF;
            .img-container{
              position: relative;
              width: 240px;
              height: 160px;
              background-color: #F7F8F9;
              border-radius: 30px;
              img{
                width: 240px;
                height: 160px;
                border-radius: 10px;
              }
            }
            .img-containers{
              position: relative;
              width: 240px;
              height: 160px;
              border-radius: 30px;
              display: flex;
              align-items: center;
              img{
                width: 240px;
                height: 104px;
                border-radius: 10px;
              }
            }
            .donation-content-right{
              flex: 1;
              padding-left: 30px;
              .donation-record-title{
                font-family: 'PingFang SC';
                font-style: normal;
                font-weight: 400;
                font-size: 28px;
                color: #887E89;
                display: inline-block;
                padding-bottom: 10px;
              }
              .donation-record-num{
                span{
                  display: inline-block;
                  font-family: 'PingFang SC';
                  font-style: normal;
                  font-weight: 400;
                  font-size: 28px;
                  color: #887E89;
                  opacity: 0.4;
                  padding-bottom: 14px;
                }
                span:nth-child(1){
                  font-family: 'PingFang SC';
                  font-style: normal;
                  font-weight: 600;
                  font-size: 40px;
                  color: #312E31;
                  opacity: 1;
                }
                 span:nth-child(2){
                  font-family: 'PingFang SC';
                  font-style: normal;
                  font-weight: 400;
                  font-size: 30;
                  color: #312E31;
                  opacity: 1;
                  padding: 0 6px;

                }
              }
              .donation-record-cert{
                span{
                  font-family: 'PingFang SC';
                  font-style: normal;
                  font-weight: 500;
                  font-size: 28px;
                  color: #A471AA;
                }
              }
            }
          }
          li:last-child{
            border-bottom: none;
          }
        }
      }
      .love-feadback{
        ul{
          li{
            margin-top: 20px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-bottom: 40px;
            border-bottom: 1px solid #DFDCDF;
            .img-container{
              position: relative;
              .img-video{
                position: absolute;
                right: 20px;
                bottom: 10px;
                img{
                  width: 70px;
                  height: 70px;
                }
              }
              img{
                width: 240px;
                height: 160px;
              }
            }
            .donation-content-right{
              flex: 1;
              padding-left: 30px;
              .donation-feadback-title{
                font-family: 'PingFang SC';
                font-style: normal;
                font-size: 34px;
                color: #312E31;
              }
              .donation-feadback-cert{
                span{
                  font-family: 'PingFang SC';
                  font-style: normal;
                  font-weight: 500;
                  font-size: 28px;
                  color: #A471AA;
                }
              }
            }
          }
        }
      }
    }
  }
  .login-content-no{
    flex: 1;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #DFDCDF;
    margin-top: 170px;
    .iconfont{
      font-size: 80px;
      color: #DFDCDF;
    }
    img{
      display: inline-block;
      width: 140px;
      height: 150px;
    }
    .no-record{
      font-family: 'PingFang SC';
      font-style: normal;
      font-weight: 400;
      font-size: 28px;
      line-height: 216%;
    }
    .login-donation{
      width: 300px;
      height: 80px;
      line-height: 80px;
      background-color: #A471AA;
      text-align: center;
      border-radius: 50px;
      margin-top: 20px;
      span{
        font-size: 30px;
        color: #FFFFFF;
      }
    }
  }
  .certimg{
    width: 650px;
    height:882px;
    img{
      width: 650px;
      height:882px;
         display: block;
    }
  }
  .cert-text{
    text-align: center;
    padding-top: 30px;
    color: #FFFFFF;
    }
  .cert-icon{
    color:#EAEAF8;
    text-align: center;
    padding-top: 70px;
    font-size: 70px;
  }
  //.swiper-wrapper{
  //  img{
  //    display: block;
  //    width:430px;
  //    height:480px;
  //
  //  }
  //}
 .video-wrapper {
  width: 680px;
  position: relative;
  height: 500px;
  margin:0 auto;
  video{
  position: absolute;
  top:0;
  left: 0;
  width: 100%;
  height: 100%
}
}

}
</style>
